module.exports = __webpack_public_path__ + "static/img/home_cn_big_date2.b44c5e9.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/home_cn_big_date2.svg
// module id = n6sr
// module chunks = 0